import { Grid, Typography } from '@mui/material';

const returnTime = time => time.slice(11, 16);

const RenderTitlesArrival = ({ arrival = false, object_option }) => (
  <Grid item>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: { xs: '0.8rem', sm: '1rem' },
        color: '#000',
      }}
    >
      {returnTime(arrival ? object_option.arrival : object_option.departure)}
    </Typography>
    <Typography
      sx={{
        fontWeight: { xs: 600, sm: 400 },
        fontSize: { xs: '0.8rem', sm: '1rem' },
        color: '#6A6A6A',
      }}
    >
      {arrival
        ? object_option.destination_airport
        : object_option.origin_airport}
    </Typography>
  </Grid>
);

export default RenderTitlesArrival;
